export default __webpack_public_path__ + "static/clothing-v2-02-pants-total-length-31a7670ef0318eaf7ec8e5a0c287429a.png";